import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";
import { useSelector } from "react-redux";

const Details = styled.div`
  margin-top: 60px;
`;

const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 6px;
  margin-bottom: 6px;
`;

const DetailsTitle = styled.div`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: left;
  color: #868686;
`;

const DetailSpan = styled.div<{ isActive?: boolean }>`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  color: black;

  ${(props) =>
    props.isActive &&
    css`
      border: 1px solid orange;
      background-color: #04ff00;
    `}
`;
const DetailsButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 20px;
  margin-top: 50px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 100%;
  }
`;

const DeactivateButton = styled.button`
  width: 192px;
  border: 1px solid #afafaf;
  border-radius: 10px;
  background-color: #afafaf;
  color: white;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 70%;
  }
`;

// const activeButon = styled.button``;

const InactiveButton = styled.button`
  width: 12%;
  border: 1px solid #e89d2b57;
  border-radius: 10px;
  background-color: #fef6eb;
  color: #e89d30;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  cursor: pointer;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 70%;
  }
`;

const EditButton = styled.button`
  border-radius: 10px;
  border: none;
  width: 192px;
  height: 44px;
  background-color: #00a603;
  color: white;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 108px;
  }
`;

const DetailsAdhoc = () => {
  const selector = useSelector(
    (state: any) => state.createpaymentlink.paymentLinkArray
  );
  console.log("selector  => ", selector);

  const obj1 = selector.map((item: any) => item.advanceOption);
  const obj2 = selector.map((item: any) => item.options);

  const ob1 = obj1[0];
  const ob2 = obj2[0];

  const combinedOptions = { ...ob1, ...ob2 };

  const detailsData = [
    { title: "Date Created", value: "Dec 03, 2023, 12:26pm" },
    { title: "Status", value: "inactive" },

    // {
    //   title: "Collect Shipping Address",
    //   value: `${combinedOptions.collectCustomersShippingAddress === true ? "Yes" : "No"}`,
    // },
    // {
    //   title: "Limit payment",
    //   value: `${combinedOptions.limitTheNumberOfPayments === true ? "Yes" : "No"}`,
    // },
  ];

  return (
    <Details>
      <div>
        <p>Details</p>
        {detailsData.map((detail, index) => (
          <DetailsRow key={index}>
            <DetailsTitle>{detail.title}</DetailsTitle>
            {detail.title === "Status" ? (
              <InactiveButton>Inactive</InactiveButton>
            ) : (
              <DetailSpan isActive={detail.value.toLowerCase() === "active"}>
                {detail.value}
              </DetailSpan>
            )}
          </DetailsRow>
        ))}
      </div>
      <DetailsButton>
        <DeactivateButton>Deactivate Link</DeactivateButton>
        <EditButton>Edit Link</EditButton>
      </DetailsButton>
    </Details>
  );
};

export default DetailsAdhoc;
